import { PartnerReferral } from "./partner-referral";

export type PartnerReferralAction =
  | PartnerReferralGetAction
  | PartnerReferralGetSuccessAction;

export const PartnerReferralGetActionType = "partner-referral/get" as const;
export type PartnerReferralGetAction = ReturnType<
  typeof partnerReferralGetAction
>;
export function partnerReferralGetAction(wisrCustomerId: string) {
  return {
    type: PartnerReferralGetActionType,
    wisrCustomerId: wisrCustomerId,
  };
}

export const PartnerReferralGetSuccessActionType =
  "partner-referral/get-success" as const;
export type PartnerReferralGetSuccessAction = ReturnType<
  typeof partnerReferralGetSuccessAction
>;
export function partnerReferralGetSuccessAction(
  partnerReferral: PartnerReferral
) {
  return {
    type: PartnerReferralGetSuccessActionType,
    partnerReferral,
  };
}
